const UploadExcelIcon = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="70" height="70" rx="35" fill="#F2F5FF" />
      <path
        d="M37.8122 23.75H26.5613C26.3126 23.75 26.0742 23.8488 25.8984 24.0246C25.7226 24.2004 25.6238 24.4389 25.6238 24.6875V45.3125C25.6238 45.5611 25.7226 45.7996 25.8984 45.9754C26.0742 46.1512 26.3126 46.25 26.5613 46.25H43.4372C43.5603 46.25 43.6822 46.2258 43.796 46.1786C43.9097 46.1315 44.0131 46.0625 44.1001 45.9754C44.1872 45.8884 44.2562 45.785 44.3033 45.6713C44.3504 45.5575 44.3747 45.4356 44.3747 45.3125V30.3125M37.8122 23.75L44.3747 30.3125M37.8122 23.75V30.3125H44.3747M31.2497 39.6875H38.7497M31.2497 35.9375H38.7497"
        stroke="#1B4DFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default UploadExcelIcon;
